import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { CommentsDialogPropsType } from './CommentsDialog.types';
import { DialogTitle, fullDateTime, useComments } from '@shared';
import { useState } from 'react';

export function CommentsDialog(props: CommentsDialogPropsType) {
  const { isModalOpen, onCloseModal, auditUuid } = props;
  const [comments, addComment, isCommentsLoading] = useComments(auditUuid);

  const [commentValue, setCommentValue] = useState('');

  const handleSendComment = () => {
    addComment(commentValue);
    setCommentValue('');
  };

  return (
    <Dialog fullWidth maxWidth='sm' open={isModalOpen} onClose={onCloseModal} closeAfterTransition>
      <DialogTitle title='Audit Comments' fontSize={24} onClose={onCloseModal} />

      <DialogContent sx={{ maxHeight: 300 }} dividers>
        <List>
          {comments && comments.length < 1 && <Typography>No Comments</Typography>}
          {isCommentsLoading && <Typography>comments are loading</Typography>}
          {!isCommentsLoading &&
            comments?.map((comment) => (
              <ListItem key={comment.uuid} disablePadding>
                <ListItemText
                  id='comment'
                  primary={
                    <Stack direction='row' gap={3} alignItems='baseline'>
                      <Typography variant='faded'>
                        {comment.firstName + ' ' + comment.lastName}
                      </Typography>
                      <Typography variant='faded' fontSize={12}>
                        {fullDateTime(comment.timestamp)}
                      </Typography>
                    </Stack>
                  }
                  secondary={<Typography sx={{ opacity: 0.8 }}>{comment.comment}</Typography>}
                />
              </ListItem>
            ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ padding: 0 }}>
        <TextField
          sx={{ margin: '16px 24px' }}
          fullWidth
          label='Write comment'
          multiline
          rows={4}
          value={commentValue}
          onChange={(e) => setCommentValue(e.target.value)}
        />
      </DialogActions>

      <DialogActions sx={{ p: '8px 24px 12px', gap: 2 }}>
        <Button disabled={!commentValue} variant='contained' onClick={handleSendComment}>
          Save Comment
        </Button>
        <Button variant='outlined' onClick={onCloseModal}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
